const getSearchParams = () => {
  const locationSearch = window.location.search;
  const searchParams = new URLSearchParams(locationSearch);
  return Object.fromEntries(searchParams);
};

export default getSearchParams;
